import React from 'react'

const DashbBoard = () => {
  return (
    <div>
      Dashboard
    </div>
  )
}

export default DashbBoard
